import { Link, Text } from "@chakra-ui/react";

export const viewNumberTableColumn = [
  {
    Header: "Name",
    accessor: "user.first_name",
    Cell: ({ value, row }) => (
      <Link href={`/#/admin/user-usage?searchText=${row.original.user.phone}`}>
        {value} {row?.original?.user?.last_name}
      </Link>
    ),
  },
  {
    Header: "Role",
    accessor: "user.role",
    Cell: ({ value }) => <span>{value || '-'}</span>,
  },
  {
    Header: "Phone",
    accessor: "user.phone",
    Cell: ({ value }) =>(
      <Link href={`/#/admin/user-usage?searchText=${value || ''}`}>
      {value || '-'}
    </Link>
    ) ,
  },
  {
    Header: "Usage",
    accessor: "usage",
    Cell: ({ value }) => <span>{value || '-'}</span>,
  },
];
